import VueI18n from "vue-i18n";

const messages = {
  en: {
    // just the suffixes
    ordinalSuffix: "th | st | nd | rd"
    // or full text example:
    // step: "{n}th step | {n}st step | {n}nd step | {n}rd step"
  }
};

// Custom pluralization for EN ordinals: 1st, 2nd, 3rd, 4th, 11th, 21st, etc.
const enOrdinalRule = (choice, choicesLength) => {
  const n = Math.abs(Number(choice));
  const v = n % 100;

  // 11th, 12th, 13th…
  if (v > 10 && v < 20) {
    return 0; // "th"
  }

  const v1 = n % 10;
  if (v1 === 1) return 1; // "st"
  if (v1 === 2) return 2; // "nd"
  if (v1 === 3) return 3; // "rd"

  return 0; // default "th"
};

export const i18n = new VueI18n({
  locale: "en",
  messages,
  pluralizationRules: {
    en: enOrdinalRule
  }
});
